<template>
  <vk-modal @close="$emit('close')">
    <div slot="header">{{ $options.TOS_TITLE }}</div>
    <div slot="content" class="x-terms-of-service">
      <div v-if="tos" v-html="tos" />
      <spinner v-else class="m-y-5 m-x-auto" />
    </div>
  </vk-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getTosById,
} from '@homeservices/api-kit/security/tos';

const TOS_TITLE = 'Pro Referral Consumer Terms of Service';

export default {
  name: 'tos-modal',
  TOS_TITLE,
  data () {
    return {
      tos: null,
    };
  },
  computed: {
    ...mapGetters('jobrequest/overview', ['tosId']),
  },
  async mounted () {
    try {
      const { data } = await getTosById(this.tosId);
      this.tos = data;
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  },
};
</script>
